import _defineProperty from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import React from 'react';
import { IconButton, Button, Typography, CircularProgress, LinearProgress } from '@material-ui/core';
import { Clear, Delete, CloudUpload, Check } from '@material-ui/icons';
import Dialog from '../../../dialog/Dialog';
import { FieldType } from '../../Form.models';
import TextField from '../Text';
import DropZone from './Dropzone';
import Api from '../../../../api';
import isUndefined from 'lodash/isUndefined';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import classnames from 'classnames';
export var FileStatus;

(function (FileStatus) {
  FileStatus["ADDED"] = "added";
  FileStatus["DELETE_PENDING"] = "delete_pending";
  FileStatus["UPLOAD_PENDING"] = "upload_pending";
  FileStatus["DONE"] = "done";
  FileStatus["DELETE_ERROR"] = "delete_error";
  FileStatus["UPLOAD_ERROR"] = "upload_error";
})(FileStatus || (FileStatus = {}));

var FileComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FileComponent, _React$Component);

  function FileComponent(props) {
    var _this;

    _classCallCheck(this, FileComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileComponent).call(this, props));
    /**
     * Добавление файлов
     * @param files
     */

    _this.onAddNewFiles = function (files) {
      _this.setState(function (prevState) {
        return {
          files: prevState.files.concat(files),
          filesInfo: prevState.filesInfo.concat(files.map(function () {
            return {
              status: FileStatus.ADDED,
              progress: 0
            };
          }))
        };
      });
    };
    /**
     * Запрос на загрузку файла
     * @param file
     * @param position
     */


    _this.sendUploadRequest = function (file, position) {
      var url = _this.props.field.params.url;
      return new Promise(function (resolve, reject) {
        var req = new XMLHttpRequest();
        /** Старт загрузки */

        req.upload.addEventListener('loadstart', function (_event) {
          _this.updateFileInfo(position, FileStatus.UPLOAD_PENDING, 0);
        });
        /** Процесс загрузки */

        req.upload.addEventListener('progress', function (event) {
          if (event.lengthComputable) {
            _this.updateFileInfo(position, FileStatus.UPLOAD_PENDING, event.loaded / event.total * 100);
          }
        });
        /** Файл загружен */

        req.upload.addEventListener('load', function (_event) {
          _this.updateFileInfo(position, undefined, 100);
        });
        /** Ошибка загрузки */

        req.upload.addEventListener('error', function (_event) {
          _this.updateFileInfo(position, FileStatus.UPLOAD_ERROR, 0, undefined);

          reject(req.response);
        });

        req.onreadystatechange = function () {
          if (req.readyState === XMLHttpRequest.DONE && req.responseText) {
            if (req.status === 200) {
              var response = JSON.parse(req.responseText);

              if (response.id) {
                _this.updateFileInfo(position, FileStatus.DONE, undefined, response.id);

                resolve(req.response);
              } else {
                _this.updateFileInfo(position, FileStatus.UPLOAD_ERROR, 0, undefined);

                reject(req.response);
              }
            } else {
              _this.updateFileInfo(position, FileStatus.UPLOAD_ERROR, 0, undefined);

              reject(req.response);
            }
          }
        };
        /** Формирование данных для отправки */


        var formData = new FormData();
        formData.append('file', file, file.name);
        /** Запрос */

        req.open('POST', url);
        req.send(formData);
      });
    };
    /**
     * Запрос на удаление файла
     * @param id
     */


    _this.sendDeleteRequest = function (id) {
      var params = _this.props.field.params;
      var url = params.files && params.files.removeUrl ? params.files.removeUrl : params.url;
      return Api.delete("".concat(url, "/").concat(id)).pipe(catchError(function (error) {
        return of(error);
      }));
    };
    /**
     * Изменение информации о файле
     * @param position
     * @param status
     * @param progress
     * @param id
     */


    _this.updateFileInfo = function (position, status, progress, id) {
      var filesInfo = _this.state.filesInfo;

      _this.setState({
        filesInfo: filesInfo.map(function (info, index) {
          return index === position ? {
            status: isUndefined(status) ? info.status : status,
            progress: isUndefined(progress) ? info.progress : progress,
            id: isUndefined(id) ? info.id : id
          } : _objectSpread({}, info);
        })
      });
    };
    /**
     * Загрузка нового файла
     * @param position
     */


    _this.uploadNewFile =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(position) {
        var files;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                files = _this.state.files;
                _context.next = 3;
                return _this.sendUploadRequest(files[position], position);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
    /**
     * Массовая загрузка новых файлов
     */


    _this.uploadNewFiles =
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var filesInfo, promises;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              filesInfo = _this.state.filesInfo;
              promises = [];

              _this.state.files.forEach(function (file, index) {
                if ([FileStatus.ADDED, FileStatus.UPLOAD_ERROR].includes(filesInfo[index].status)) {
                  // загружаем только не загруженные
                  promises.push(_this.sendUploadRequest(file, index));
                }
              });

              _context2.prev = 3;
              _context2.next = 6;
              return Promise.all(promises);

            case 6:
              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](3);
              console.log(_context2.t0);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 8]]);
    }));
    /**
     * Удаление нового файла
     * @param position
     */

    _this.deleteNewFile = function (position) {
      var filesInfo = _this.state.filesInfo;
      var info = filesInfo[position];

      if ((info.status === FileStatus.DONE || info.status === FileStatus.DELETE_ERROR) && info.id) {
        _this.setState({
          filesInfo: filesInfo.map(function (info, index) {
            if (index === position) {
              return _objectSpread({}, info, {
                status: FileStatus.DELETE_PENDING
              });
            }

            return _objectSpread({}, info);
          })
        });

        _this.sendDeleteRequest(info.id).subscribe(function (response) {
          var _this$state = _this.state,
              files = _this$state.files,
              filesInfo = _this$state.filesInfo;

          if (response.status === 200) {
            // если удаление успешное, удаляем файл и инфу из стейта
            _this.setState({
              files: files.filter(function (_file, index) {
                return index !== position;
              }),
              filesInfo: filesInfo.filter(function (_info, index) {
                return index !== position;
              })
            });
          } else {
            // если не получилось удалить, то добавляем об этом инфу в стейт
            _this.setState({
              filesInfo: filesInfo.map(function (info, index) {
                if (index === position) {
                  return _objectSpread({}, info, {
                    status: FileStatus.DELETE_ERROR
                  });
                }

                return _objectSpread({}, info);
              })
            });
          }
        }, function (error) {
          console.log(error);
        });
      } else {
        var files = _this.state.files;

        _this.setState({
          files: files.filter(function (_file, index) {
            return index !== position;
          }),
          filesInfo: filesInfo.filter(function (_info, index) {
            return index !== position;
          })
        });
      }
    };
    /**
     * Массовое удаление новых файлов
     */


    _this.deleteNewFiles = function () {
      var _this$state2 = _this.state,
          files = _this$state2.files,
          filesInfo = _this$state2.filesInfo;
      var requests = [];
      var deletedPositions = [];
      var clearedPositions = [];
      filesInfo.forEach(function (info, index) {
        if ((info.status === FileStatus.DONE || info.status === FileStatus.DELETE_ERROR) && info.id) {
          requests.push(_this.sendDeleteRequest(info.id));
          deletedPositions.push(index);
        } else {
          clearedPositions.push(index);
        }
      }); // удаление незагруженных файлов

      if (clearedPositions.length > 0) {
        _this.setState({
          files: files.filter(function (_file, index) {
            return !clearedPositions.includes(index);
          }),
          filesInfo: filesInfo.filter(function (_info, index) {
            return !clearedPositions.includes(index);
          })
        });
      }

      if (deletedPositions.length > 0) {
        _this.setState({
          filesInfo: filesInfo.map(function (info, index) {
            if (deletedPositions.includes(index)) {
              return _objectSpread({}, info, {
                status: FileStatus.DELETE_PENDING
              });
            }

            return _objectSpread({}, info);
          })
        });
      }

      forkJoin(requests).subscribe(function (responses) {
        _this.setState({
          files: files.filter(function (_file, index) {
            return !deletedPositions.includes(index) || responses[deletedPositions.indexOf(index)].status !== 200;
          }),
          filesInfo: filesInfo.map(function (info, index) {
            if (deletedPositions.includes(index) && responses[deletedPositions.indexOf(index)].status !== 200) {
              return _objectSpread({}, info, {
                status: FileStatus.DELETE_ERROR
              });
            }

            return _objectSpread({}, info);
          }).filter(function (_info, index) {
            return !deletedPositions.includes(index) || responses[deletedPositions.indexOf(index)].status !== 200;
          })
        });
      }, function (error) {
        console.log(error);
      });
    };
    /**
     * Удаление сохраненного файла
     * @param position
     */


    _this.deleteSavedFile = function (position) {
      var value = _this.props.value;
      var savedFileStatuses = _this.state.savedFileStatuses;
      var id = value[position].id;

      _this.setState({
        savedFileStatuses: savedFileStatuses.map(function (status, index) {
          return index === position ? FileStatus.DELETE_PENDING : status;
        })
      });

      _this.sendDeleteRequest(id).subscribe(function (response) {
        if (response.status === 200) {
          var newValue = value.filter(function (file) {
            return file.id !== id;
          });

          _this.setState({
            savedFileStatuses: savedFileStatuses.filter(function (status, index) {
              return index === position;
            })
          });

          _this.updateFieldValue(newValue, true);
        } else {
          _this.setState({
            savedFileStatuses: savedFileStatuses.map(function (status, index) {
              return index === position ? FileStatus.DELETE_ERROR : status;
            })
          });
        }
      }, function (error) {
        console.log(error);
      });
    };
    /**
     * Массовое удаление сохраненных файлов
     */


    _this.deleteSavedFiles = function () {
      var value = _this.props.value;

      if (value && isArray(value)) {
        var requests = [];
        value.forEach(function (file) {
          requests.push(_this.sendDeleteRequest(file.id));
        });

        _this.setState({
          savedFileStatuses: Array(value.length).fill(FileStatus.DELETE_PENDING)
        });

        forkJoin(requests).subscribe(function (responses) {
          var newValue = value.filter(function (_file, index) {
            return responses[index].status !== 200;
          });

          _this.setState({
            savedFileStatuses: newValue.length > 0 ? Array(newValue.length).fill(FileStatus.DELETE_ERROR) : []
          });

          _this.updateFieldValue(newValue.length > 0 ? newValue : undefined, true);
        }, function (error) {
          console.log(error);
        });
      }
    };
    /**
     * Сохраняем новые загруженные файлы
     */


    _this.saveNewFiles = function () {
      var _this$state3 = _this.state,
          files = _this$state3.files,
          filesInfo = _this$state3.filesInfo;
      var value = _this.props.value;
      var deletedPositions = [];
      var newValue = filesInfo.filter(function (info, index) {
        if ((info.status === FileStatus.DONE || info.status === FileStatus.DELETE_ERROR) && info.id) {
          deletedPositions.push(index);
          return true;
        }

        return false;
      }).map(function (info, index) {
        return {
          id: info.id,
          name: files[index].name
        };
      });

      if (value && isArray(value)) {
        newValue = _toConsumableArray(value).concat(newValue);
      }

      _this.setState({
        files: files.filter(function (_file, index) {
          return !deletedPositions.includes(index);
        }),
        filesInfo: filesInfo.filter(function (_info, index) {
          return !deletedPositions.includes(index);
        })
      });

      _this.updateFieldValue(newValue, true);
    };
    /**
     * Обновление значения поля
     * @param newValue
     * @param hard
     */


    _this.updateFieldValue = function (newValue, hard) {
      var _this$props = _this.props,
          onFieldChange = _this$props.onFieldChange,
          id = _this$props.id,
          field = _this$props.field;
      onFieldChange(id || field.name, newValue.length > 0 ? newValue : undefined, false, hard);
    };

    _this.renderFileRows = function (isAllSuccess, isAllUploading) {
      var _this$props2 = _this.props,
          classes = _this$props2.classes,
          value = _this$props2.value;
      var files = _this.state.files;
      return (!!files.length || value && isArray(value) && !!value.length) && React.createElement("div", {
        className: classes.uploadFiles
      }, value && isArray(value) && React.createElement(React.Fragment, null, React.createElement(Typography, {
        variant: 'subtitle2'
      }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0435"), value.map(function (file, index) {
        return React.createElement("div", {
          key: "old_".concat(file.name, "_").concat(index),
          className: classes.uploadRow
        }, _this.renderSavedFileRow(file, index));
      })), !!files.length && React.createElement(React.Fragment, null, React.createElement(Typography, {
        variant: 'subtitle2'
      }, "\u041D\u043E\u0432\u044B\u0435"), files.map(function (file, index) {
        return React.createElement("div", {
          key: "new_".concat(file.name, "_").concat(index),
          className: classes.uploadRow
        }, _this.renderNewFileRow(file, index));
      }), React.createElement("div", {
        className: classes.newFilesActions
      }, React.createElement(Button, {
        disabled: isAllSuccess || isAllUploading,
        variant: 'outlined',
        color: 'primary',
        size: 'small',
        onClick: _this.uploadNewFiles
      }, "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0432\u0441\u0435"), React.createElement(Button, {
        variant: 'outlined',
        color: 'default',
        onClick: _this.deleteNewFiles,
        size: 'small',
        style: {
          marginLeft: 8
        }
      }, "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0432\u0441\u0435"))));
    };
    /**
     * Рендер строки с сохраненным файлом
     * @param file
     * @param position
     */


    _this.renderSavedFileRow = function (file, position) {
      var classes = _this.props.classes;
      var savedFileStatuses = _this.state.savedFileStatuses;
      var isDeletePending = savedFileStatuses[position] === FileStatus.DELETE_PENDING;
      var isDeleteError = savedFileStatuses[position] === FileStatus.DELETE_ERROR;
      return React.createElement(React.Fragment, null, React.createElement("div", {
        className: classes.uploadFilenameWrapper
      }, React.createElement("div", {
        className: classes.uploadFilename
      }, React.createElement(Check, {
        fontSize: 'small',
        className: classes.uploadSuccessIcon
      }), React.createElement("span", null, file.name)), React.createElement("div", {
        className: classes.uploadRowActions
      }, isDeletePending ? _this.renderCircularProgress() : React.createElement(IconButton, {
        "aria-label": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0444\u0430\u0439\u043B",
        onClick: function onClick() {
          return _this.deleteSavedFile(position);
        },
        size: 'small'
      }, React.createElement(Delete, {
        fontSize: 'small'
      })))), isDeleteError && React.createElement("span", {
        className: classes.uploadErrorText
      }, "\u041E\u0448\u0438\u0431\u043A\u0430 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u0444\u0430\u0439\u043B\u0430"));
    };
    /**
     * Рендер строки с выбранным файлом
     * @param file
     * @param position
     */


    _this.renderNewFileRow = function (file, position) {
      var classes = _this.props.classes;
      var filesInfo = _this.state.filesInfo;
      var status = filesInfo[position].status;
      var isAdded = status === FileStatus.ADDED;
      var isDone = status === FileStatus.DONE;
      var isUploadError = status === FileStatus.UPLOAD_ERROR;
      var isDeleteError = status === FileStatus.DELETE_ERROR;
      var isUploadPending = status === FileStatus.UPLOAD_PENDING;
      var isDeletePending = status === FileStatus.DELETE_PENDING;
      return React.createElement(React.Fragment, null, React.createElement("div", {
        className: classes.uploadFilenameWrapper
      }, React.createElement("div", {
        className: classes.uploadFilename
      }, (isDone || isDeleteError || isDeletePending) && React.createElement(Check, {
        fontSize: 'small',
        className: classes.uploadSuccessIcon
      }), React.createElement("span", null, file.name)), React.createElement("div", {
        className: classes.uploadRowActions
      }, (isUploadPending || isDeletePending) && _this.renderCircularProgress(), (isAdded || isUploadError) && React.createElement(IconButton, {
        "aria-label": "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C",
        onClick: function onClick() {
          return _this.uploadNewFile(position);
        },
        size: 'small'
      }, React.createElement(CloudUpload, {
        fontSize: 'small'
      })), !isUploadPending && React.createElement(IconButton, {
        "aria-label": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0444\u0430\u0439\u043B",
        onClick: function onClick() {
          return _this.deleteNewFile(position);
        },
        size: 'small'
      }, React.createElement(Delete, {
        fontSize: 'small'
      })))), isUploadPending && _this.renderLinearProgress(file, position), (isUploadError || isDeleteError) && React.createElement("span", {
        className: classes.uploadErrorText
      }, isUploadError && 'Ошибка загрузки файла', isDeleteError && 'Ошибка удаления файла'));
    };
    /**
     * Рендер полосы прогресса загрузки файла
     * @param file
     * @param position
     */


    _this.renderLinearProgress = function (file, position) {
      var filesInfo = _this.state.filesInfo;
      return React.createElement(LinearProgress, {
        variant: 'determinate',
        value: filesInfo[position].progress
      });
    };
    /**
     * Рендер индикатора удаления
     */


    _this.renderCircularProgress = function () {
      var classes = _this.props.classes;
      return React.createElement("div", {
        className: classes.circularProgressWrapper
      }, React.createElement(CircularProgress, {
        className: classes.circularProgress,
        size: 18
      }));
    };
    /**
     * Заглушка обработки изменения значения текстового поля
     */


    _this.onFieldChange = function () {// do nobaseg
    };
    /**
     * Открытие модального окна поиска
     */


    _this.onOpen = function () {
      _this.setState({
        opened: true
      });
    };
    /**
     * Закрытие модального окна поиска
     */


    _this.onClose = function () {
      _this.setState({
        opened: false
      });
    };
    /**
     * Очистка значения поля
     */


    _this.onClear = function (event) {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();

      _this.deleteNewFiles();

      _this.deleteSavedFiles();
    };
    /**
     * Получение текста для отображения в поле
     */


    _this.getInputValue = function () {
      var value = _this.props.value;
      var inputValue = '';

      if (value && isArray(value)) {
        if (value.length > 1) {
          var cases = [2, 0, 1, 1, 1, 2];
          var titles = ['файл', 'файла', 'файлов'];
          var count = value.length;
          var text = titles[count % 100 > 4 && count % 100 < 20 ? 2 : cases[count % 10 < 5 ? count % 10 : 5]];
          inputValue = "".concat(count, " ").concat(text);
        } else if (value.length === 1 && isObject(value[0]) && 'name' in value[0]) {
          inputValue = value[0].name;
        }
      }

      return inputValue;
    };

    var value = props.value;
    _this.state = {
      opened: false,
      files: [],
      filesInfo: [],
      savedFileStatuses: value && isArray(value) ? value.map(function () {
        return FileStatus.DONE;
      }) : []
    };
    return _this;
  }

  _createClass(FileComponent, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          field = _this$props3.field,
          classes = _this$props3.classes,
          slim = _this$props3.slim,
          fieldParams = _this$props3.field.params;

      if (fieldParams && fieldParams.url) {
        var _this$state4 = this.state,
            opened = _this$state4.opened,
            files = _this$state4.files,
            filesInfo = _this$state4.filesInfo;
        var isAllSuccess = filesInfo.length > 0 && filesInfo.every(function (_ref3) {
          var status = _ref3.status;
          return status === FileStatus.DONE || status === FileStatus.DELETE_ERROR;
        });
        var isAllUploading = filesInfo.length > 0 && filesInfo.every(function (_ref4) {
          var status = _ref4.status;
          return status === FileStatus.UPLOAD_PENDING;
        });
        var extensions = fieldParams.files && fieldParams.files.extensions;
        var inputValue = this.getInputValue();

        var fieldProps = _objectSpread({}, this.props, {
          field: _objectSpread({}, field, {
            type: FieldType.Text
          }),
          value: inputValue
        });

        return React.createElement(React.Fragment, null, React.createElement("div", {
          className: classes.fieldContainer
        }, React.createElement(TextField, Object.assign({}, fieldProps, {
          onFieldChange: this.onFieldChange
        })), React.createElement("div", {
          className: classes.findFieldButton,
          onClick: this.onOpen
        }, inputValue && React.createElement(IconButton, {
          className: classnames(classes.clearButton, _defineProperty({}, classes.clearButtonSlim, slim)),
          size: slim ? 'small' : 'medium',
          "aria-label": "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u043F\u043E\u043B\u0435",
          onClick: this.onClear
        }, React.createElement(Clear, {
          fontSize: slim ? 'small' : 'default'
        })))), opened && React.createElement(Dialog, {
          open: true,
          onClose: this.onClose,
          title: "\u0424\u0430\u0439\u043B\u044B",
          disableEnforceFocus: true,
          slim: slim
        }, React.createElement("div", {
          className: classes.uploadContainer
        }, React.createElement("div", {
          className: classes.uploadContent
        }, React.createElement(DropZone, {
          classes: classes,
          onAddNewFiles: this.onAddNewFiles,
          disabled: isAllUploading,
          extensions: extensions
        }), this.renderFileRows(isAllSuccess, isAllUploading)), files.length > 0 && React.createElement("div", {
          className: classes.uploadActions
        }, React.createElement(Button, {
          variant: 'contained',
          color: 'primary',
          onClick: this.saveNewFiles,
          disabled: !isAllSuccess || isAllUploading
        }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")))));
      }

      return null;
    }
  }]);

  return FileComponent;
}(React.Component);

var File = function File(props) {
  return React.createElement(FileComponent, Object.assign({}, props));
};

export default File;